import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { JackBaseComponentModule, MaterialModule, PageKind, UiModeType } from 'jk-service';
import { UtyscService, templateUrlConfigUty } from '../_service_uty';
import { UtyscEditComponent, } from '../_edit_uty';
import { jkSingleComponent, AdvComModule } from 'jk-advcom';



@Component({
  selector: 'app-utypi03-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './utypi03-detailPkg.component.html',//templateUrlConfigUty.utypi03_detail,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utypi03DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'utypi03-detail';
  constructor() {
    super();
    this.srv = new UtyscService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'SC001=MAINTABLE,SC002=ITEM';
    this.masterEditPage = UtyscEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'SC003', sort: 'asc', defaultSort: null, pageKind: PageKind.bill };

    // this.constructorInit(); // ###

  }

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    this.srv.cdr = this.cdr;
  };


}
